export const CHECKBOX_LIST_INITIALIZE = 'CHECKBOX_LIST_INITIALIZE'
export const CHECKBOX_LIST_UPDATE = 'CHECKBOX_LIST_UPDATE'
export const CHECKBOX_LIST_DESTROY = 'CHECKBOX_LIST_DESTROY'
